import { DEFAULT_CURRENCY_ISO_CODE } from 'constants/constants'

const createFormatter = ({
  currencyIsoCode = DEFAULT_CURRENCY_ISO_CODE,
  showCents = true,
}) =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyIsoCode,
    maximumFractionDigits: showCents ? 2 : 0,
    minimumFractionDigits: showCents ? 2 : 0,
  })

export const formatPrice = ({ value, currencyIsoCode, showCents }) =>
  createFormatter({ currencyIsoCode, showCents }).format(
    Number.isNaN(value) ? 0 : value
  )
